import type { AbsolutePosition } from '@app/types'

export const BUTTON_POSITION: AbsolutePosition = {
  bottom: 23,
  right: -12
}
